import angular from 'angular';

angular.module('neurotecAbisWebClientApp')
	.directive('openFile', () => ({
		template: require('../../../views/directives/latent-editor/open-file.html'),
		restrict: 'E',
		replace: true,
		scope: {
			file: '='
		}
	}));
